import script from "./ReportInaccuracy.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportInaccuracy.vue?vue&type=script&setup=true&lang=js"

import "./ReportInaccuracy.vue?vue&type=style&index=0&id=8b8059ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b8059ac"]])

export default __exports__